import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
// import { ConnectedRouter } from 'react-router-redux';
import { OidcProvider, processSilentRenew } from "redux-oidc";

import 'bulma-tooltip/dist/css/bulma-tooltip.min.css';
import {registerObserver} from 'react-perf-devtool';
import "./App.css";
import Main from "./Containers/main/Main";
import registerServiceWorker from "./registerServiceWorker";
import store from "./store/store";
// import { history } from './store/store';
import userManager from "./utils/userManager";

registerObserver();

if (window.location.pathname === '/silent_renew.html') {
  processSilentRenew()
} else {
  ReactDOM.render(
    <Provider store={store}>
      <OidcProvider store={store} userManager={userManager}>
        {/*<ConnectedRouter history={history}>*/}
        <Main />
        {/*</ConnectedRouter> */}
      </OidcProvider>
    </Provider>,
    document.getElementById("root") as HTMLElement
    );
  }
  registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.tsx